<template>
  <div class="games-page-inner">
    <!-- 顶部 Banner -->
    <img class="banner" src="/static/image/73b07f2.jpg" alt="banner" />

    <div class="games-page-content">
      <!-- 分类 Tab -->
      <div class="games-tab-wrapper">
        <ul class="games-tab">
          <li :class="{ active: gamecode == null }" @click="changgamecode(null)">推荐</li>
          <li :class="{ active: gamecode == 'obgdy' }" @click="changgamecode('obgdy')">OB电子</li>
          <li :class="{ active: gamecode == 'fgdz' }" @click="changgamecode('fgdz')">FG电子</li>
          <li :class="{ active: gamecode == 'pp' }" @click="changgamecode('pp')">PP电子</li>
          <li :class="{ active: gamecode == 'ae' }" @click="changgamecode('ae')">AE电子</li>
        </ul>
      </div>

      <!-- 推荐列表 -->
      <ul class="game-list" v-if="gamecode == null">
        <li v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1"
            class="game-list-item"
            @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
          <div class="game-cover-wrapper">
            <img class="game-picture" :src="`/static/image/concise/${item.platform_name}dz.png`" />
          </div>
          <h4 class="game-title">{{ item.name }}</h4>
        </li>
      </ul>

      <!-- 分类通用列表 -->
      <ul class="game-list" v-if="gamecode == 'obgdy'">
        <li v-for="(item, index) in obgdyList" :key="index" class="game-list-item"
            @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div class="game-cover-wrapper">
            <img class="game-picture" :src="item.gamepic" />
          </div>
          <h4 class="game-title">{{ item.gamename }}</h4>
        </li>
        <li v-if="obgdyList.length === 0" class="empty-text">暂无数据</li>
      </ul>

      <ul class="game-list" v-if="gamecode == 'fgdz'">
        <li v-for="(item, index) in fgdzList" :key="index" class="game-list-item"
            @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div class="game-cover-wrapper">
            <img class="game-picture" :src="item.gamepic" />
          </div>
          <h4 class="game-title">{{ item.gamename }}</h4>
        </li>
        <li v-if="fgdzList.length === 0" class="empty-text">暂无数据</li>
      </ul>

      <ul class="game-list" v-if="gamecode == 'pp'">
        <li v-for="(item, index) in ppList" :key="index" class="game-list-item"
            @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div class="game-cover-wrapper">
            <img class="game-picture" :src="item.gamepic" />
          </div>
          <h4 class="game-title">{{ item.gamename }}</h4>
        </li>
        <li v-if="ppList.length === 0" class="empty-text">暂无数据</li>
      </ul>

      <ul class="game-list" v-if="gamecode == 'ae'">
        <li v-for="(item, index) in aeList" :key="index" class="game-list-item"
            @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div class="game-cover-wrapper">
            <img class="game-picture" :src="item.gamepic" />
          </div>
          <h4 class="game-title">{{ item.gamename }}</h4>
        </li>
        <li v-if="aeList.length === 0" class="empty-text">暂无数据</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'games',
  data() {
    return {
      gamecode: null,
      obgdyList: [],
      fgdzList: [],
      ppList: [],
      aeList: [],
      gameList: [],
    };
  },
  created() {
    this.getGameList();
  },
  methods: {
    getGameList() {
      this.$parent.showLoading();
      this.$apiFun.get('/api/game/list', { category: 'concise' }).then(res => {
        if (res.code == 200) {
          this.gameList = res.data;
        }
        this.$parent.hideLoading();
      });
    },
    changgamecode(code) {
      if (code == this.gamecode) return;
      this.gamecode = code;
      if (code != null) {
        this.gamelistBycode();
      }
    },
    gamelistBycode() {
      let name = this.gamecode + 'List';
      if (this[name].length > 0) return;
      this.$parent.showLoading();
      this.$apiFun.post('/api/gamelistBycode', { gamecode: this.gamecode })
        .then(res => {
          if (res.code == 200) {
            this[name] = res.data;
          } else {
            this.$parent.showTost(0, res.message);
          }
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.games-page-inner {
  background: #fff;
  min-height: 100vh;
}

.banner {
  width: 100%;
  display: block;
}

.games-page-content {
  padding: 16px;

  /* 分类按钮 */
  .games-tab {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 刚好 5 个一行 */
    gap: 8px;
    margin-bottom: 20px;

    li {
      text-align: center;
      padding: 8px 0;
      font-size: 13px;
      color: #666;
      background: #f5f5f5;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #eaeaea;
      }

      &.active {
        background: #007bff;
        color: #fff;
        font-weight: 500;
      }
    }
  }

  /* 游戏列表 */
  .game-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 三个一排 */
    gap: 16px;

    .game-list-item {
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.08);
      overflow: hidden;
      text-align: center;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 10px rgba(0,0,0,0.15);
      }

      .game-cover-wrapper {
        width: 100%;
        height: 120px;
        background: #fafafa;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .game-picture {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }

      .game-title {
        font-size: 13px;
        color: #333;
        margin: 8px 0 12px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    /* 空数据提示 */
    .empty-text {
      grid-column: span 3;
      text-align: center;
      color: #999;
      font-size: 14px;
      padding: 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/games.vue